import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { fromEvent, Subject, timer } from 'rxjs';
import { mapTo, scan, takeUntil, takeWhile, throttleTime } from 'rxjs/operators';
import * as StrategyActions from '../../../strategy/strategy.actions';

import { toggleNotification } from '@shared/animations/shared.animations';

@Component({
  selector: 'app-content-notification',
  templateUrl: './content-notification.component.html',
  styleUrls: ['./content-notification.component.scss'],
  animations: [toggleNotification('toggleNotification', '400ms', '350ms')],
  standalone: false
})
export class ContentNotificationComponent implements OnInit, OnDestroy {
  @Input() type: 'success' | 'warning' = 'success';
  @Input() messages: string[];
  @Input() showUndoMessage: boolean;
  @Input() undoLoading: boolean;

  scrollPosition: number;

  protected readonly onDestroy$ = new Subject<void>();

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.scrollPosition = window.scrollY;
    this.runTimer();

    fromEvent(window, 'scroll')
      .pipe(throttleTime(300), takeUntil(this.onDestroy$))
      .subscribe(() => {
        const newScrollPosition = window.scrollY;
        if (newScrollPosition > this.scrollPosition) {
          this.hideMessage();
        }
        this.scrollPosition = newScrollPosition;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  runTimer() {
    timer(0, 1000)
      .pipe(
        mapTo(-1),
        scan((acc, value) => {
          return acc + value;
        }, 6),
        takeWhile((value) => value >= 0),
        takeUntil(this.onDestroy$)
      )
      .subscribe((value) => {
        if (value === 0) {
          this.hideMessage();
        }
      });
  }

  hideMessage() {
    this.store.dispatch(StrategyActions.hideBrokenPortfolioUndoMessage());
  }
}
